import "../stylesheets/App.css";
import "../stylesheets/Login.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./subcomponents/Loader.js";

function Login() {
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showPass, setShowPass] = useState(false);

  const navigate = useNavigate();

  // ✅ Redirecciones fuera del render
  useEffect(() => {
    const raw = localStorage.getItem("user-info");
    if (!raw) return;

    try {
      const user = JSON.parse(raw);
      if (user?.is_admin) navigate("/admin");
      else navigate("/");
    } catch {
      // si el localStorage está corrupto, lo limpiamos
      localStorage.removeItem("user-info");
    }
  }, [navigate]);

  // fondo exclusivo de login
  useEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  // scroll OK
  useEffect(() => {
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "auto";
  }, []);

  const handleShowPass = () => setShowPass((prev) => !prev);

  const login = async () => {
    setErrorMsg("");
    setLoadingLogin(true);

    try {
      const item = { email, password };

      let result = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/users/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );

      result = await result.json();
      setLoadingLogin(false);

      if (result.status === 200) {
        localStorage.setItem("user-info", JSON.stringify(result.data));
        localStorage.setItem("category", result.data.idCategory);

        if (result.data.is_admin) navigate("/admin");
        else navigate("/");
        return;
      }

      if (result.status === 201) {
        localStorage.setItem("user-email", JSON.stringify(result.data.email));

        if (result?.errors?.errors?.[0]?.msg === "CODIGOSINVALIDAR") {
          navigate("/validate-email");
        } else {
          navigate("/temp-password");
        }
        return;
      }

      setErrorMsg(result?.data?.errors?.[0]?.msg || "Credenciales inválidas");
    } catch (e) {
      console.log(e);
      setLoadingLogin(false);
      setErrorMsg("Error de conexión. Intentá nuevamente.");
    }
  };

  return (
    <>
      <img
        className="banner-login"
        src={process.env.PUBLIC_URL + "/images/login/Logo-Login-HMQ-2.png"}
        alt=""
      />
      <div className="flex-container">
        <img
          className="tittle-login"
          src={process.env.PUBLIC_URL + "/images/login/Login-Tittle-2.png"}
          alt=""
        />
      </div>

      <div className="login-content section-70">
        <div className="login-input">
          <img
            src={process.env.PUBLIC_URL + "/images/icons/Message.png"}
            className="login-input-icon"
            alt=""
          />
          <input
            type="text"
            className="inp"
            placeholder="Correo electrónico"
            id="email"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="login-input">
          <img
            src={process.env.PUBLIC_URL + "/images/icons/Password.png"}
            className="login-input-icon"
            alt=""
          />
          <input
            type={showPass ? "text" : "password"}
            className="inp"
            placeholder="Contraseña"
            id="password"
            name="password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <img
            className="show-pass"
            onClick={handleShowPass}
            alt=""
            src={
              process.env.PUBLIC_URL +
              (showPass
                ? "/images/icons/open-eye.svg"
                : "/images/icons/close-eye.svg")
            }
          />
        </div>

        <p>
          <a className="forget-pass" onClick={() => navigate("/forgot-password")}>
            <strong className="text-azul-brand">¿Olvidaste tu contraseña?</strong>
          </a>
        </p>

        <div>
          <span className="error-msg">{errorMsg}</span>
        </div>
        <div className="login-btn-container">
        <button
          type="submit"
          className="btn red-btn mb-4"
          id="login"
          onClick={login}
        >
          Acceder
        </button>

        <button
          className="btn blue-btn"
          id="register"
          onClick={() => navigate("/register")}
        >
          Registrarse
        </button>
        </div>
      </div>

      {loadingLogin ? <Loader /> : ""}

      <div className="flex-container">
        <p className="register-text">
          ¿No tienes una cuenta?{" "}
          <a className="register-now" onClick={() => navigate("/register")}>
            <strong className="text-azul-brand">Registrate ahora</strong>
          </a>
        </p>
      </div>
      <img className="login-bottom-img" src={process.env.PUBLIC_URL + "/images/login/login-bottom-img.png"}/>
    </>
  );
}

export default Login;
